<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I thank the Lord for showering me with the Light of the Spirit of Truth! Thanks to my mom and dad who gave me life. I thank my son Rosen – a gift from God to me and my greatest like-minded person and friend. Thank you to everyone who believed in my path in the spiritual dimensions and got involved in the process of publishing my novels. I will be very happy if the new edition of the novel <em>8 Seconds</em> becomes popular enough through Austin Macauley Publishers to attract the attention of film producers to invest in making the film.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?61bb8b9e